import React, { Component, ErrorInfo, ReactNode } from 'react'
import { Card, Button, Result } from 'antd'
import { ReloadOutlined, HomeOutlined } from '@ant-design/icons'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Unhandled UI Error:', error, errorInfo)
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'grid', placeItems: 'center', minHeight: '80vh', padding: 24 }}>
          <Card style={{ maxWidth: 540, width: '100%', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
            <Result
              status="warning"
              title="Display Error"
              subTitle="An unexpected rendering issue occurred on this view. Don't worry, all your data remains safe."
              extra={[
                <Button type="primary" icon={<ReloadOutlined />} key="reload" onClick={this.handleReset} style={{ background: '#001A4D', borderColor: '#001A4D' }}>
                  Reload Page
                </Button>,
                <Button icon={<HomeOutlined />} key="home" onClick={() => { window.location.href = '/' }}>
                  Go to Dashboard
                </Button>,
              ]}
            />
          </Card>
        </div>
      )
    }

    return this.props.children
  }
}
